import { jewlr_t, IS_NA } from "helpers/application"

export const faqData = () => [
  {
    text: "This plan provides accident protection from damaged prongs, clasps, hinges, earring backs, and more. Extend plans are in effect from day one, and even extend your coverage from defects in workmanship and/or materials, including normal wear and tear after the manufacturer's warranty expires.",
    title: "Why should I add an accidental damage plan?  ",
  },
  {
    text: `An Extend ${jewlr_t(
      "terms.Jewelry"
    )} ADH Protection Plan can be purchased during the checkout process online or by contacting our Customer Service Team at ${
      sl.config.customer_service_toll_free
    }. You can also purchase a  ${jewlr_t(
      "terms.Jewelry"
    )} ADH Protection Plan retroactively up to 60 days past the date you purchased your  ${jewlr_t(
      "terms.jewelry"
    )} item.`,
    title: `How can I purchase an Extend ${jewlr_t(
      "terms.Jewelry"
    )} ADH Protection Plan?`,
  },
  {
    text: `The Extend ${jewlr_t(
      "terms.Jewelry"
    )} ADH Protection Plan covers bracelets, earrings, necklaces, rings, charms and pendants,  ${jewlr_t(
      "terms.jewelry"
    )} sets, anklets, brooches and lapel pins. The Extend team and Jewlr work together to identify all eligible products and match them to a protection plan.`,
    title: "What products are covered?",
  },
]

export const protectionPlanData = () => [
  {
    icon: "jewlr4-NoMoneyNoProblems",
    label: null,
    price: "20.99",
    text: "Zero Deductible",
    year: "2 Year",
  },
  {
    icon: "jewlr4-easy-online-claims",
    label: "Best Seller!",
    price: "28.99",
    text: "Easy Online Claims",
    year: "3 Year",
  },
  {
    icon: "accident-protection",
    label: "Best Value!",
    price: "36.99",
    text: "Accident Protection",
    year: "5 Year",
  },
]

export const whatsCoveredData = () => [
  {
    icon: "jewlr4-product-repair",
    text: `Free replacement or repair if something should happen to your ${jewlr_t(
      "terms.jewelry"
    )}${sl.config.enable_watches ? " or watch" : ""}.`,
    title: "Replacement Or Repair",
  },
  {
    icon: "jewlr4-peace-of-mind-icon",
    text: `Wear your ${jewlr_t("terms.jewelry")}${
      sl.config.enable_watches ? " and watch" : ""
    } with confidence – we have you covered!`,
    title: "Peace of mind",
  },
  {
    icon: "jewlr4-zero-deductible",
    text: `No fees. No deductibles. No hidden costs to repair your ${jewlr_t(
      "terms.jewelry"
    )}.`,
    title: "Zero Deductible",
  },
  {
    icon: "jewlr4-customer-focused-support-icon",
    text: "We’re always happy to help.",
    title: "Customer focused support",
  },
  {
    icon: "jewlr4-accidental-damage",
    text: `Your ${jewlr_t(
      "terms.jewelry"
    )} is protected when accidental damage occurs.`,
    title: "Accidental Damage",
  },
  {
    icon: "jewlr4-added-benefits",
    text: IS_NA()
      ? "Free ring sizing, rhodium plating, polishing, and more!"
      : "Rhodium plating, polishing, and more!",
    title: `Added ${jewlr_t("terms.jewelry")} Benefits`,
  },
]
